/**
 * @readonly
 * @enum {string}
 */
export const ObjectClasses = {
    EQUIPMENT: 'EQUIPMENT',
    MACHINERY: 'MACHINERY',
    TRAILER: 'TRAILER',
    VEHICLE: 'VEHICLE'
}
